// LoadingSpinnerOverlay.jsx
import React from "react";
import { CircularProgress } from "@mui/material";
import { Overlay } from "./styles";
import { useUI } from "context/ui/uiContext";

const LoadingSpinnerOverlay = () => {
  const { isLoading } = useUI();

  if (isLoading) {
    return (
      <Overlay>
        <CircularProgress />
      </Overlay>
    );
  }

  return null;
};

export default LoadingSpinnerOverlay;
